import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalHeader, FormGroup, FormFeedback, Input, Form, Label} from 'reactstrap'
import PropTypes from 'prop-types'
import CreatableSelect from '../Wps/CreatableSelect'
import {FillerMaterialStandardsFetch, createFillerMaterialMutation} from './mutations'
import {graphql, compose} from 'react-apollo'
import BlockWithLoader from '../Support/BlockWithLoader'
import {WpsStandardizationsAndMaterialsFetch} from '../Wps/mutations'

class FillerMaterialModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      validation_errors: {},
      classification: []
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    createFillerMaterialMutation: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    afterSubmit: PropTypes.func.isRequired
  }

  handleSubmit(event) {
    event.stopPropagation()
    event.preventDefault()
    const form_elements = event.target.elements
    this.props.createFillerMaterialMutation({
      variables: {
        standard_id: Number(form_elements.standard_id.value),
        trade_name: form_elements.trade_name.value,
        classification: this.state.classification.map(o => o.name)
      },
      update: (store, {data: {createFillerMaterial}}) => {
        if (!createFillerMaterial.errors) {
          const data = store.readQuery({query: WpsStandardizationsAndMaterialsFetch})
          data.filler_materials.splice(0, 0, createFillerMaterial.filler_material)
          store.writeQuery({
            query: WpsStandardizationsAndMaterialsFetch,
            data,
          })
        }
      },
    }).then(({data: {createFillerMaterial}}) => {
      if (createFillerMaterial.errors) {
        this.setState({validation_errors: JSON.parse(createFillerMaterial.errors)})
      } else {
        this.props.afterSubmit(createFillerMaterial.filler_material)
      }
    })
  }

  prepareStandardOptions() {
    if (this.props.data.filler_material_standards) {
      return this.props.data.filler_material_standards.map(o => (
        <option key={o.id} value={o.id}>{`${o.name} - ${o.description}`}</option>))
    }
  }

  render() {
    if (this.props.data.error) {
      return (<div>An unexpected error occurred</div>)
    }

    return (
      <BlockWithLoader loading={this.props.data.loading}>
        <Modal isOpen={true}>
          <ModalHeader>Add new Filler material</ModalHeader>
          <ModalBody>
            <Form id="filler-material-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
              <FormGroup>
                <Label for="trade-name-filler-material-form">Trade name</Label>
                <Input type="text" name="trade_name" id="trade-name-filler-material-form" required/>
                <FormFeedback>{this.state.validation_errors.trade_name}</FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label for="standard-filler-material-form">Standard</Label>
                <Input type="select" name="standard_id" id="standard-filler-material-form" required>
                  <option/>
                  {this.prepareStandardOptions()}
                </Input>
                <FormFeedback>{this.state.validation_errors.standard}</FormFeedback>
              </FormGroup>

              <FormGroup>
                <CreatableSelect
                  label="Classification"
                  id="classification-filler-material-form"
                  valueKey="name"
                  placeholder="Type each classification symbol and separate it by pressing enter"
                  value={this.state.classification}
                  multi={true}
                  creatable={true}
                  valueChangeFunction={val => {
                    this.setState({classification: val})
                  }}
                />
                <FormFeedback>{this.state.validation_errors.classification}</FormFeedback>
              </FormGroup>

              <hr/>
              <Button id="cancel-filler-material-form-btn" className="float-right" color="danger"
                onClick={this.props.onCancel}>Cancel</Button>
              <Button id="save-filler-material-form-btn" className="float-right" color="primary" type="submit">Save</Button>
            </Form>
          </ModalBody>
        </Modal>
      </BlockWithLoader>
    )
  }
}

const FillerMaterialModalWithMutations = compose(
  graphql(FillerMaterialStandardsFetch, {
    options: {fetchPolicy: 'network-only'}
  }),
  graphql(createFillerMaterialMutation, {name: 'createFillerMaterialMutation'}),
)(FillerMaterialModal)

export default FillerMaterialModalWithMutations



// WEBPACK FOOTER //
// ./src/components/Dictionary/FillerMaterialModal.js